import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  clipsPageAdditionalMeta,
  clipsPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-with-whip-small.jpg';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/general/GeneralHeader';
import ClipsPageMainContainer from '../../components/clips/ClipsPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function ClipsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Clips & Fansites'
        desc={`Unlock exclusive content, private clips, and premium experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`}
        keywords={KeywordsPages}
        additionalMeta={clipsPageAdditionalMeta}
        structuredData={clipsPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          {/* Header */}
          <GeneralHeader
            title='Clips & Fansites'
            subtitle={MainTitle}
            imageUrl={MainImage}
            imageText={
              <>
                SEE <br /> MORE
              </>
            }
            imageAlt={`${CompanyName} looking sinful`}
          >
            <p>
              <strong className='text-colour5'>Craving more?</strong> Dive
              deeper into my world, where every fantasy unfolds in tantalizing
              detail. My exclusive clips and content are waiting for you — ready
              to be devoured.
            </p>

            <p>
              Whether you desire{' '}
              <strong className='text-colour5'>
                powerful wrestling domination
              </strong>
              , the seductive tease of <em>sensual submission</em>, or the messy
              indulgence of{' '}
              <strong className='text-colour5'>
                sploshing and fetish play
              </strong>
              , I have crafted a collection of unforgettable experiences just
              for you.
            </p>

            <p>
              Unlock your access to 🔞uncensored content🔞 and private sessions
              through my
              <strong className='text-colour5'> premium platforms.</strong> See
              me in action, surrender to the thrill, and indulge in what you’ve
              only dared to imagine.
            </p>

            <p className='pb-2'>
              <span className='text-lg font-StencilW01 text-colour5'>
                Explore more on:
              </span>
            </p>
            <ul className='list-disc list-inside'>
              <li>
                <strong className='text-colour5'>Mintstars</strong> – Exclusive
                content & personal interactions
              </li>
              <li>
                <strong className='text-colour5'>Clips4Sale</strong> – Premium,
                high-quality fetish videos
              </li>
            </ul>

            <p>
              Your deepest desires are just a click away.
              <strong className='text-colour5'>
                {' '}
                Don't just watch — experience!
              </strong>
            </p>
          </GeneralHeader>

          {/* Main page content */}
          <ClipsPageMainContainer />

          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default ClipsPage;
